// Referrence tailwindcss: https://tailwindcss.com/docs

const BG_OPACITY_OPTIONS: any = {
  '0': 'opacity-0',
  '10': 'opacity-10',
  '20': 'opacity-20',
  '30': 'opacity-30',
  '40': 'opacity-40',
  '50': 'opacity-50',
  '60': 'opacity-60',
  '70': 'opacity-70',
  '80': 'opacity-80',
  '90': 'opacity-90',
  '100': 'opacity-100',
};

const PADDING_OPTIONS: any = {
  none: 'p-0',
  sm: 'p-4 sm:px-8 sm:py-8',
  md: 'p-4 sm:px-16 sm:py-12',
  lg: 'p-4 sm:px-24 sm:py-16',
};

export const SHADOW_OPTIONS: any = {
  none: 'shadow-none',
  xs: 'shadow-xs',
  sm: 'shadow-sm',
  md: 'shadow-md',
  lg: 'shadow-lg',
  xl: 'shadow-xl',
};

const BORDER_RADIUS_OPTIONS: any = {
  none: 'rounded-none',
  xs: 'rounded-xs',
  sm: 'rounded-sm',
  md: 'rounded-md',
  lg: 'rounded-lg',
  xl: 'rounded-xl',
  '2xl': 'rounded-2xl',
  '3xl': 'rounded-3xl',
};

const BORDER_WIDTH_OPTIONS: any = {
  xs: 'border',
  sm: 'border-2',
  md: 'border-4',
  lg: 'border-8',
};

const BORDER_SIDE_T_OPTIONS: any = {
  xs: 'border-t',
  sm: 'border-t-2',
  md: 'border-t-4',
  lg: 'border-t-8',
};

const BORDER_SIDE_B_OPTIONS: any = {
  xs: 'border-b',
  sm: 'border-b-2',
  md: 'border-b-4',
  lg: 'border-b-8',
};

const BORDER_SIDE_L_OPTIONS: any = {
  xs: 'border-l',
  sm: 'border-l-2',
  md: 'border-l-4',
  lg: 'border-l-8',
};

const BORDER_SIDE_R_OPTIONS: any = {
  xs: 'border-r',
  sm: 'border-r-2',
  md: 'border-r-4',
  lg: 'border-r-8',
};

const BORDER_SIDE_X_OPTIONS: any = {
  xs: 'border-x',
  sm: 'border-x-2',
  md: 'border-x-4',
  lg: 'border-x-8',
};

const BORDER_SIDE_Y_OPTIONS: any = {
  xs: 'border-y',
  sm: 'border-y-2',
  md: 'border-y-4',
  lg: 'border-y-8',
};

const SIDE_OPTIONS: any = {
  all: BORDER_WIDTH_OPTIONS,
  top: BORDER_SIDE_T_OPTIONS,
  bottom: BORDER_SIDE_B_OPTIONS,
  left: BORDER_SIDE_L_OPTIONS,
  right: BORDER_SIDE_R_OPTIONS,
  'x-axis': BORDER_SIDE_X_OPTIONS,
  'y-axis': BORDER_SIDE_Y_OPTIONS,
};

export {
  BG_OPACITY_OPTIONS,
  BORDER_RADIUS_OPTIONS,
  BORDER_SIDE_B_OPTIONS,
  BORDER_SIDE_L_OPTIONS,
  BORDER_SIDE_R_OPTIONS,
  BORDER_SIDE_T_OPTIONS,
  BORDER_SIDE_X_OPTIONS,
  BORDER_SIDE_Y_OPTIONS,
  BORDER_WIDTH_OPTIONS,
  PADDING_OPTIONS,
  SIDE_OPTIONS,
};
